import { render, staticRenderFns } from "./SealingPage.vue?vue&type=template&id=e2a0a796&scoped=true"
import script from "./SealingPage.vue?vue&type=script&lang=js"
export * from "./SealingPage.vue?vue&type=script&lang=js"
import style0 from "./SealingPage.vue?vue&type=style&index=0&id=e2a0a796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a0a796",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
